<template>
    <div id="ShareItem">
        <b-modal
                id="mod-share"
                no-close-on-esc
                no-close-on-backdrop
                header-class=itsBkg
                body-class=itsBkg
                footer-class=itsBkg
        >
            <template v-slot:modal-header>
                <span>{{$t("SHARE1")}}
                <b-button id="link-button" @click="copyLink()"
                >
                    {{$t("SHARE2")}}
                </b-button>
                <b-popover
                    ref="popover"
                    target="link-button"
                    :title="$t('COPIED')"
                    placement="bottom"
                >
                </b-popover>
                {{$t("SHARE3")}}</span>
                 <b-button size="sm" @click="close()">
                    x
                </b-button>
            </template>
<!--
            <b-button pill variant="success" :href="fb" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'facebook-f']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            <b-button pill variant="danger" :href="inst" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'instagram']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            &nbsp;
            <b-button pill variant="warning" :href="tw" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'twitter']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            &nbsp;

-->

            <b-button pill variant="primary" :href="vk" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'vk']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            &nbsp;
            <b-button pill variant="secondary" :href="ok" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'odnoklassniki']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            &nbsp;
            <b-button pill variant="info" :href="pi" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'pinterest']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            &nbsp;
            <b-button pill variant="success" :href="rd" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'reddit-alien']" size="lg" :style="{ color: 'white' }" />
            </b-button>
            &nbsp;
            <b-button pill variant="warning" :href="tad" rel="nofollow" target="_blank">
                <font-awesome-icon :icon="['fab', 'tripadvisor']" size="lg" :style="{ color: 'white' }" />
            </b-button>

            <template v-slot:modal-footer>
                <b-button @click="close()">
                    {{ $t("CLOSE")}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { BModal, BButton, BPopover } from 'bootstrap-vue';

export default {
  name: 'ShareItem',
  components: {
    BModal, BButton, BPopover
  },
  data: function() {
    return {
        url: '',
        fb: '',
        tw: '',
        inst: '',
        vk: '',
        ok: '',
        pi: '',
        rd: '',
        tad: '',
        pin: ''
    }
  },
  mounted() {
    this.url = window.location;
    this.fb = 'http://www.facebook.com';
    this.tw = 'https://twitter.com';
    this.inst = 'https://instagram.com';
    this.vk = 'https://vk.com';
    this.ok = 'https://ok.ru';
    this.pi = 'https://pinterest.com';
    this.rd = 'https://reddit.com';
    this.tad = 'https://tripadvisor.com';
    this.pin = 'https://pinterest.com';
    this.$bvModal.show('mod-share');
  },
  methods: {
    close() {
        this.$bvModal.hide('mod-share');
        this.$emit('closeShare');
    },
    copyLink() {
        this.$refs.popover.$emit('open')
        const el = document.createElement('textarea');
        el.addEventListener('focusin', e => e.stopPropagation());
        el.value = this.url;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setTimeout(() => {
            this.$refs.popover.$emit('close')
        }, 750);
    }
  }
}
</script>